import styled from '@emotion/styled'

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 16px;
  margin-bottom: 16px;
`

export const FormField = styled.div`
  margin-bottom: 16px;
  label {
    display: block;
    margin-bottom: 4px;
    font-weight: 500;
    color: #262626;
  }
`

export const BadgeContainer = styled.div`
  .ant-tag {
    margin-bottom: 4px;
  }
`

export const ArrayItemCard = styled.div`
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  padding: 16px;
  margin-bottom: 16px;
  background: white;
  position: relative;
`

export const RemoveButton = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
`
